import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import useAuth from 'src/hooks/useAuth';
import { CompanyTreeResponse } from 'src/types/work_area';
import axiosInstance from 'src/utils/axios';

/** Raw company hierarchy tree. Filtering is applied in WorkAreaContext / useFilteredCompanyTree. */
const useCompanyTreeQuery = (rootCompanyId: number | null) => {
  const { user } = useAuth();
  const clientId = user?.ClientId;

  return useQuery<CompanyTreeResponse>({
    queryKey: queryKeys.workArea.companyTree(rootCompanyId, clientId ?? null),
    queryFn: async () => {
      if (!clientId || rootCompanyId == null) {
        throw new Error('Missing clientId or rootCompanyId for company tree.');
      }
      const res = await axiosInstance.get<CompanyTreeResponse>(
        api.getCompanyTree(rootCompanyId)
      );
      return res.data;
    },
    enabled: Boolean(clientId && rootCompanyId != null),
  });
};

export default useCompanyTreeQuery;
